import { render, staticRenderFns } from "./creationCompetition.vue?vue&type=template&id=2420d854&scoped=true"
import script from "./creationCompetition.vue?vue&type=script&lang=js"
export * from "./creationCompetition.vue?vue&type=script&lang=js"
import style0 from "./creationCompetition.vue?vue&type=style&index=0&id=2420d854&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2420d854",
  null
  
)

export default component.exports